import React from "react";
import { Box, Grid, useTheme } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { Base } from ".";
import ColumnDef from "../../types/columnDef";

interface Props {
  headers: ColumnDef[];
  mobileRows: any[];
  totalRows?: number;
  next?: () => void;
  mobileBackgroundColor?: string;
}

const MobileTableView: React.FC<Props> = (props) => {
  const { headers, totalRows, next, mobileRows, mobileBackgroundColor } = props;
  const theme = useTheme();

  const loadInfiniteScroll = async () => {
    if (next) {
      next();
    }
  };

  return (
    <InfiniteScroll
      dataLength={mobileRows.length}
      next={loadInfiniteScroll}
      hasMore={mobileRows.length >= totalRows! ? false : true}
      loader={<Base.Text text={next ? "Loading, please wait..." : ""} center />}
      endMessage={
        <Base.Text text={next ? "No remaining results" : ""} center />
      }
      scrollThreshold={0.6}
    >
      {mobileRows.map((row, rowKey) => {
        return (
          <Base.AccordionSwitch
            innerAccordion
            key={rowKey}
            title={row.mobileTitle || row.name}
            backgroundColor={mobileBackgroundColor}
            content={
              <Grid
                container
                sx={{
                  borderBottom: "1px solid #000",
                  borderTop: "1px solid #000",
                  backgroundColor: theme.palette.background.paper,
                }}
              >
                {Object.values(headers).map((value: any, valueKey) => {
                  return (
                    <Grid
                      key={valueKey}
                      size={{ xs: value.mobileSize ?? 6 }}
                      sx={{
                        padding: "5px",
                        display: "flex",
                        flexDirection: value.mobileDirection ?? "row",
                        alignItems: "center",
                        border: "1px solid #E6EEF7",
                        gap: 1,
                      }}
                    >
                      <Box sx={{ fontWeight: 600 }}>
                        <Base.Text text={`${value.headerName}`} />
                      </Box>
                      <Base.Text text={row[value.field]} component="span" />
                    </Grid>
                  );
                })}
              </Grid>
            }
          />
        );
      })}
    </InfiniteScroll>
  );
};

export default MobileTableView;
